import { gsapGrid } from '../components/tools';
import { gsap } from 'gsap';

const init = async (parent) => {
  return new Promise((resolve) => {
    gsapGrid(
      '.columns',
      '.column__item',
      {
        autoAlpha: 0,
        y: 50,
        scale: 0.7,
      },
      {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        stagger: 0.08,
        ease: gsap.parseEase('0.86,0,0.07,1'),
      },
      0.64,
      600
    );

    return resolve('Banner Home component loaded');
  });
};

export { init };
